/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React from 'react'
import RatingGuideImg from '@assets/images/guide/ratio-guide.jpg'
import RatingSImg from '@assets/images/icon/my_page_icon/rating-S.png'
import RatingAImg from '@assets/images/icon/my_page_icon/rating-A.png'
import RatingBImg from '@assets/images/icon/my_page_icon/rating-B.png'
import RatingCImg from '@assets/images/icon/my_page_icon/rating-C.png'
import RatingDImg from '@assets/images/icon/my_page_icon/rating-D.png'
import styled from '@themes/theme'
import { ACTIVITY_RANK_TYPE } from '@v2/constants/activity'
import { Schema$UserActivitySummary } from '@interface/user-activity'

const RatingInfoWrap = styled.div`
  width: 100%;
  height: auto;
  max-height: 500px;
  overflow: auto;

  .my-score {
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: 16px 0 21px;
    color: ${props => props.theme.color.modalgray};
    font-size: ${props => props.theme.font.large};
    font-weight: ${props => props.theme.fontW.medium};
    background: ${props => props.theme.color.themeTxt};
    border-top: 1px solid ${props => props.theme.color.modalBg};

    .score-wrap {
      margin: 5px 0 9px;
      padding: 6px 14px;
      border-radius: 50px;
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.xlarge};
      background: ${props => props.theme.color.modalBg};

      .rating-img {
        width: auto;
        height: 25px;
        margin-right: 10px;
        transform: translateY(-3px);
      }

      .score {
        display: inline-block;
        transform: translateY(1px);
        color: inherit;
        font-size: ${props => props.theme.font.xxlarge};
      }
    }

    .point-color--blue--dark {
      font-size: ${props => props.theme.font.large};

      .underline {
        position: relative;
        color: inherit;
        font-size: inherit;

        &::before {
          content: '';
          display: block;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 90%;
          height: 6px;
          background: ${props => props.theme.color.secondaryBg};
          opacity: .15;
        }
      }
    }
  }

  img {
    width: inherit;
    height: auto;
  }
`


export interface RatingInfoProps {
  userActivity: Schema$UserActivitySummary
}

export const RatingInfo: React.FC<RatingInfoProps> = observer((props) => {
  const { userActivity } = props

  let rankImg
  switch (userActivity.monthlyActivityRank) {
    case ACTIVITY_RANK_TYPE.S_RANK:
      rankImg = <img src={RatingSImg} alt="S등급" className="rating-img"/>
      break
    case ACTIVITY_RANK_TYPE.A_RANK:
      rankImg = <img src={RatingAImg} alt="A등급" className="rating-img"/>
      break
    case ACTIVITY_RANK_TYPE.B_RANK:
      rankImg = <img src={RatingBImg} alt="B등급" className="rating-img"/>
      break
    case ACTIVITY_RANK_TYPE.C_RANK:
      rankImg = <img src={RatingCImg} alt="C등급" className="rating-img"/>
      break
    case ACTIVITY_RANK_TYPE.D_RANK:
      rankImg = <img src={RatingDImg} alt="D등급" className="rating-img"/>
      break
    case ACTIVITY_RANK_TYPE.N_RANK:
      rankImg = null
      break
  }

  return (
    <RatingInfoWrap>
      <div className="my-score">
        내 점수
        <div className="score-wrap">
          {rankImg}
          <span className="score">{userActivity.monthlyActivityScore}</span>점
        </div>
        <div className="point-color--blue--dark">
          <span className="underline">분석글, 댓글 작성 시</span> 활동점수 획득!
        </div>

      </div>
      <img src={RatingGuideImg} alt="활동등급 안내"/>
    </RatingInfoWrap>
  )
})
